import { useMemo } from 'react';
import { useLocation } from 'react-router';

export function useQuery(name: string): string {
    const location = useLocation();
    return useMemo(() => {
        const URLParser = new URLSearchParams(location.search);
        return URLParser.get(name);
    }, [location.search]);
}
